// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------------------
   Global Wrapper & Layout
------------------------------------------------------------- */
.main-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 20px;
  background-color: #f8f9fa;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.checker-card {
  width: 100%;
  max-width: 1200px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 30px;
  box-sizing: border-box;
}

.header-main-title {
  font-size: 24px;
  color: #212529;
  margin-top: 0;
  margin-bottom: 25px;
  font-weight: 700;
  text-align: center;
}

/* -------------------------------------------------------------
   Input Section (URL & File Upload)
------------------------------------------------------------- */
.input-section {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap; /* Allows stacking on mobile */
  margin-bottom: 24px;
}

/* Base styles for labels */
.input-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

/* Wrapper to hold input elements safely */
.input-section > div {
  flex: 1 1;
  min-width: 280px; /* Forces stack if viewport drops below this width */
  width: 100%;
}

.url-input, 
.file-input {
  width: 100%;
  height: 42px;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background-color: black;
  box-sizing: border-box;
  transition: border-color 0.15s ease-in-out;
}

.url-input:focus {
  outline: none;
  border-color: #4db6ac;
  box-shadow: 0 0 0 3px rgba(77, 182, 172, 0.25);
}

/* Style the native file picker */
.file-input {
  padding: 6px 12px;
  cursor: pointer;
}

/* Submit Button */
.check-btn {
  height: 42px;
  padding: 0 24px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.check-btn:hover:not(:disabled) {
  background-color: #0056b3;
}

.check-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.7;
}

/* -------------------------------------------------------------
   Live Progress Section
------------------------------------------------------------- */
.progress-section {
  background-color: #fdfdfd !important;
  border: 1px solid #e9ecef;
  box-shadow: inset 0 1px 3px rgba(0,0,0,.02);
}

.progress-section h5 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #343a40;
}

/* Results Grid */
.results-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.status-column-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-column {
    background: #fdfdfd;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 6px;
    max-height: 600px;
    overflow-y: auto;
}

.header-title {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #38bdf8;
}

.online-title { color: #28a745; border-color: #28a745; }
.offline-title { color: #dc3545; border-color: #dc3545; }

/* List Item Styling */
.stream-item {
    padding: 10px;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.stream-info { width: 100%; }

.stream-name {
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 3px;
}

.stream-url {
    display: block;
    font-size: 0.8rem;
    color: #6c757d;
    word-break: break-all;
    font-family: monospace;
}

.copy-button {
    background: #007bff;
    color: white;
    border: none;
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 0.75rem;
    cursor: pointer;
    max-width: 50px;
}

.copy-button:hover { background: #0056b3; }

.offline-badge {
    color: #dc3545;
    font-weight: bold;
    font-size: 0.8rem;
}

/* Universal Export Button Styling */
.export-btn {
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* Specific Style for Online List Export */
.online-export-btn {
  background-color: #28a745;
  color: #fff;
}

.online-export-btn:hover {
  background-color: #218838;
}

/* Specific Style for Offline List Export */
.offline-export-btn {
  background-color: #6c757d;
  color: #fff;
}

.offline-export-btn:hover {
  background-color: #5a6268;
}

/* -------------------------------------------------------------
   📱 Responsive Media Queries (Mobile Optimization)
------------------------------------------------------------- */
@media (max-width: 768px) {
  .checker-card {
    padding: 15px;
  }

  .header-main-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  /* Make URL and File Inputs collapse into stacked full-width rows */
  .input-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .input-section > div {
    min-width: 100%;
  }

  .check-btn {
    width: 100%; /* Full width button on mobile for easy finger tapping */
    margin-top: 5px;
  }

  /* CRITICAL: Collapse Online and Offline lists into a single vertical scroll */
  .results-container {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .status-column {
    max-height: 400px; /* Shorter scroll window on mobile devices */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/PlaylistChecker.css"],"names":[],"mappings":"AAAA;;+DAE+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe,EAAE,8BAA8B;EAC/C,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,SAAO;EACP,gBAAgB,EAAE,oDAAoD;EACtE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB,cAAc,EAAE,qBAAqB,EAAE;AACvD,iBAAiB,cAAc,EAAE,qBAAqB,EAAE;;AAExD,sBAAsB;AACtB;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA,eAAe,WAAW,EAAE;;AAE5B;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;AAC/D;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,mEAAmE;EACnE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW,EAAE,wDAAwD;IACrE,eAAe;EACjB;;EAEA,8EAA8E;EAC9E;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB,EAAE,4CAA4C;EACjE;AACF","sourcesContent":["/* -------------------------------------------------------------\n   Global Wrapper & Layout\n------------------------------------------------------------- */\n.main-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 100vh;\n  padding: 20px;\n  background-color: #f8f9fa;\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.checker-card {\n  width: 100%;\n  max-width: 1200px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  padding: 30px;\n  box-sizing: border-box;\n}\n\n.header-main-title {\n  font-size: 24px;\n  color: #212529;\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-weight: 700;\n  text-align: center;\n}\n\n/* -------------------------------------------------------------\n   Input Section (URL & File Upload)\n------------------------------------------------------------- */\n.input-section {\n  display: flex;\n  gap: 15px;\n  align-items: flex-end;\n  flex-wrap: wrap; /* Allows stacking on mobile */\n  margin-bottom: 24px;\n}\n\n/* Base styles for labels */\n.input-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n}\n\n/* Wrapper to hold input elements safely */\n.input-section > div {\n  flex: 1;\n  min-width: 280px; /* Forces stack if viewport drops below this width */\n  width: 100%;\n}\n\n.url-input, \n.file-input {\n  width: 100%;\n  height: 42px;\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  background-color: black;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease-in-out;\n}\n\n.url-input:focus {\n  outline: none;\n  border-color: #4db6ac;\n  box-shadow: 0 0 0 3px rgba(77, 182, 172, 0.25);\n}\n\n/* Style the native file picker */\n.file-input {\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n/* Submit Button */\n.check-btn {\n  height: 42px;\n  padding: 0 24px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  white-space: nowrap;\n}\n\n.check-btn:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.check-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* -------------------------------------------------------------\n   Live Progress Section\n------------------------------------------------------------- */\n.progress-section {\n  background-color: #fdfdfd !important;\n  border: 1px solid #e9ecef;\n  box-shadow: inset 0 1px 3px rgba(0,0,0,.02);\n}\n\n.progress-section h5 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  color: #343a40;\n}\n\n/* Results Grid */\n.results-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n}\n\n.status-column-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.status-column {\n    background: #fdfdfd;\n    border: 1px solid #eee;\n    border-radius: 10px;\n    padding: 6px;\n    max-height: 600px;\n    overflow-y: auto;\n}\n\n.header-title {\n  text-align: center;\n  font-size: 1.2rem;\n  margin-bottom: 10px;\n  color: #38bdf8;\n}\n\n.online-title { color: #28a745; border-color: #28a745; }\n.offline-title { color: #dc3545; border-color: #dc3545; }\n\n/* List Item Styling */\n.stream-item {\n    padding: 10px;\n    border-bottom: 1px solid #f1f1f1;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.stream-info { width: 100%; }\n\n.stream-name {\n    display: block;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 3px;\n}\n\n.stream-url {\n    display: block;\n    font-size: 0.8rem;\n    color: #6c757d;\n    word-break: break-all;\n    font-family: monospace;\n}\n\n.copy-button {\n    background: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 12px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    cursor: pointer;\n    max-width: 50px;\n}\n\n.copy-button:hover { background: #0056b3; }\n\n.offline-badge {\n    color: #dc3545;\n    font-weight: bold;\n    font-size: 0.8rem;\n}\n\n/* Universal Export Button Styling */\n.export-btn {\n  width: 100%;\n  padding: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* Specific Style for Online List Export */\n.online-export-btn {\n  background-color: #28a745;\n  color: #fff;\n}\n\n.online-export-btn:hover {\n  background-color: #218838;\n}\n\n/* Specific Style for Offline List Export */\n.offline-export-btn {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n.offline-export-btn:hover {\n  background-color: #5a6268;\n}\n\n/* -------------------------------------------------------------\n   📱 Responsive Media Queries (Mobile Optimization)\n------------------------------------------------------------- */\n@media (max-width: 768px) {\n  .checker-card {\n    padding: 15px;\n  }\n\n  .header-main-title {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n\n  /* Make URL and File Inputs collapse into stacked full-width rows */\n  .input-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .input-section > div {\n    min-width: 100%;\n  }\n\n  .check-btn {\n    width: 100%; /* Full width button on mobile for easy finger tapping */\n    margin-top: 5px;\n  }\n\n  /* CRITICAL: Collapse Online and Offline lists into a single vertical scroll */\n  .results-container {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n  \n  .status-column {\n    max-height: 400px; /* Shorter scroll window on mobile devices */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
